// Audition Admin Frame 711

import React, { useState } from "react";
import Banner from "../../../assets/images/BannerAuditionAdmin.png";
import Profo from "../../../assets/images/shahruk-khan.jpg";
import Profo2 from "../../../assets/images/flag.png";
import Profo3 from "../../../assets/images/finish.png";
import { useParams } from "react-router-dom";
import { Markup } from "interweave";
import axios from "axios";
import { useEffect } from "react";
import moment from "moment";
import StarAU from "./StarAU";
import EventRfS from "./EventRfS";
import EventsRfM from "./EventsRfM";
import RoundVR from "./RoundVR";
import AppliedU from "./AppliedU";

const PendingAuditionDetails = () => {
  const { slug } = useParams();
  const [event, setEvent] = useState({});
  const [judges, setJudges] = useState([]);

  return (
    <div>
      
      <div className="container card card-bg border-warning p-3  my-3">
        <h5 className="text-warning fw-bold  text-center Fsdsd">
        Audition Title name here
        </h5>
        <div className="photoRelative">
          <img
            src={Banner}
            className="img-fluid audioBanner my-3"
            alt=""
          />
        </div>

        <h5 className="text-warning  fw-bold mt-3">Audition Description</h5>
        <p className="text-light text-justify">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the Lorem Ipsum is simply dummy text of
          the printing and typesetting industry. Lorem Ipsum has been the Lorem
          Ipsum is simply dummy text of the printing and typesetting industry.
          Lorem Ipsum has been the Lorem Ipsum is simply dummy text of the
          printing and typesetting industry. Lorem Ipsum has been the Lorem
          Ipsum is simply dummy text of the printing and typesetting industry.
        </p>
         <h5 className="text-warning  fw-bold mt-3">Super Star</h5>
        <center className="row justify-content-center align-items-center my-3">
          <div className="col-md-4 mb-2">
            <div className="card bsStar">
              <center>
                <img
                  src={Profo}
                  alt=""
                  width={80}
                  height={80}
                  style={{ borderRadius: "50%" }}
                  className="my-3"
                />
                <h5 className="textStarName">Super Star 01</h5>
              </center>
            </div>
            <div className="d-flex StarAdminBG justify-content-center p-2">
              <div className="div">
                <img
                  src={Profo}
                  alt=""
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%" }}
                />
              </div>
              <div className="text-light pt-2 ps-4">SuperStar Admin</div>
            </div>
          </div>
          <div className="col-md-4 mb-2">
            <div className="card bsStar">
              <center>
                <img
                  src={Profo}
                  alt=""
                  width={80}
                  height={80}
                  style={{ borderRadius: "50%" }}
                  className="my-3"
                />
                <h5 className="textStarName">Super Star 02</h5>
              </center>
            </div>
            <div className="d-flex StarAdminBG justify-content-center p-2">
              <div className="div">
                <img
                  src={Profo}
                  alt=""
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%" }}
                />
              </div>
              <div className="text-light pt-2 ps-4">SuperStar Admin</div>
            </div>
          </div>
          <div className="col-md-4 mb-2">
            <div className="card bsStar">
              <center>
                <img
                  src={Profo}
                  alt=""
                  width={80}
                  height={80}
                  style={{ borderRadius: "50%" }}
                  className="my-3"
                />
                <h5 className="textStarName">Super Star 03</h5>
              </center>
            </div>
            <div className="d-flex StarAdminBG justify-content-center p-2">
              <div className="div">
                <img
                  src={Profo}
                  alt=""
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%" }}
                />
              </div>
              <div className="text-light pt-2 ps-4">SuperStar Admin</div>
            </div>
          </div>
        </center>

        <div className="mx-5">
          <div className="row mt-4 jurify-content-between align-items-center">
            <div className="col-md-4 mb-3">
              <h5 className="text-warning fw-bold">Event Time Boundary</h5>
            </div>

            <div className="d-flex col-md-4  mb-3 ">
              <div className="card BGBlueS">
                <div className="d-flex ">
                  <div className="col-md-2 p-2 me-3">
                    <img src={Profo2} alt="" width={40} height={40}  />
                  </div>
                  <div className=" col-md-10 text-light ps-21">
                    <div>Start</div>
                    <div>2 April 2022</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex col-md-4  mb-3 ">
              <div className="card BGBlueG">
                <div className="d-flex ">
                  <div className="col-md-2 p-2 me-3">
                    <img src={Profo3} alt="" width={40} height={40}  />
                  </div>
                  <div className=" col-md-10 text-light ps-1">
                    <div>End</div>
                    <div>2 April 2022</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" my-3">
          <h5 className="text-warning fw-bold mb-4">Assigned Jury</h5>
          <div className="StarAdminBc">
            <h5 className="text-light p-3 GroupHeader ">Group A</h5>
            <center className="row justify-content-center align-items-center my-4 p-3">
              <div className="col-md-4 mb-2">
                <div className="BXCStar  pb-3 mb-3">
                  <center>
                    <img
                      src={Profo}
                      alt=""
                      width={120}
                      height={120}
                      style={{ borderRadius: "50%" }}
                      className="my-3"
                    />
                    <h4 className="text-light">Oni Hasan</h4>
                    <h6 className="TextNX">Music </h6>
                    <h6 className="TextNX">Specialist</h6>
                  </center>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="BXCStar  pb-3 mb-3">
                  <center>
                    <img
                      src={Profo}
                      alt=""
                      width={120}
                      height={120}
                      style={{ borderRadius: "50%" }}
                      className="my-3"
                    />
                    <h4 className="text-light">Oni Hasan</h4>
                    <h6 className="TextNX">Music </h6>
                    <h6 className="TextNX">Specialist</h6>
                  </center>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="BXCStar  pb-3 mb-3">
                  <center>
                    <img
                      src={Profo}
                      alt=""
                      width={120}
                      height={120}
                      style={{ borderRadius: "50%" }}
                      className="my-3"
                    /> 
                    <h4 className="text- light">Oni Hasan</h4>
                    <h6 className="TextN X">Music </h6>
                    <h6 className="TextN X">Specialist</h6>
                  </center> 
                </div> 
              </div> 
              <div className="col-md-4 m b-2">
                <div className="BXCStar   pb-3 mb-3">
                  <center>
                    <img
                      src={Profo}
                      alt=""
                      width={120}
                      height={120}
                      style={{ borderRadius: "50%" }}
                      className="my-3"
                    />
                    <h4 className="text-light">Oni Hasan</h4>
                    <h6 className="TextNX">Music </h6>
                    <h6 className="TextNX">Specialist</h6>
                  </center>
                </div>
              </div>
            </center>
          </div>
        </div>

        
        {/* <AppliedU/>
        <RoundVR/>
        <EventsRfM/>
        <EventRfS/>
        <StarAU/> */}
      </div>
    </div>
  );
};

export default PendingAuditionDetails;
